import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { message } from 'ant-design-vue'
import MessageTextField from '@/components/message/MessageTextField.vue'
import MessageUploadQueue from '@/components/message/MessageUploadQueue.vue'
import MessageUploader from '@/components/message/MessageUploader.vue'

interface UploadedFileType extends File {
  url?: string
}

interface CommentType {
  body: string | null
  files: UploadedFileType[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageAddCommentCard',
  emits: ['commentAdded'],
  setup(__props, { emit }) {


const route = useRoute()
const saving = ref(false)

const comment = ref<CommentType>({
  body: null,
  files: []
})

const allowedMimeTypes = [
  'image/jpg',
  'image/png',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
]

function addFile (file:File) {
  const enriched:UploadedFileType = Object.assign(file, {
    url: URL.createObjectURL(file)
  })

  comment.value.files.push(enriched)
}

function storeComment () : void {
  if (!comment.value.body) return
  saving.value = true

  const formData = new FormData()
  formData.append('body', comment.value.body)

  comment.value.files.forEach((file:File) => {
    formData.append('files[]', file)
  })

  axios.post(process.env.VUE_APP_API_URL_V2 + '/messages/' + route.params.messageId + '/comments', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((r) => {
    emit('commentAdded', r.data.data)
    comment.value = { body: null, files: [] }
    message.success('Opmerking succesvol toegevoegd.')
  }).finally(() => {
    saving.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "Opmerking toevoegen" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        class: "no-mb",
        gutter: [16,16]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(MessageTextField, {
                content: comment.value.body,
                onContentChange: _cache[0] || (_cache[0] = ($event: any) => (comment.value.body = $event))
              }, null, 8, ["content"])
            ]),
            _: 1
          }),
          (comment.value.files.length)
            ? (_openBlock(), _createBlock(_component_a_col, {
                key: 0,
                span: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(MessageUploadQueue, {
                    files: comment.value.files,
                    onDeleteFile: _cache[1] || (_cache[1] = ($event: any) => (comment.value.files.splice($event, 1)))
                  }, null, 8, ["files"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                class: "mr-8",
                loading: saving.value,
                disabled: saving.value,
                onClick: storeComment
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Opmerking toevoegen")
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              (!saving.value)
                ? (_openBlock(), _createBlock(MessageUploader, {
                    key: 0,
                    allowedMimeTypes: allowedMimeTypes,
                    fileCount: comment.value.files.length,
                    onNewFile: _cache[2] || (_cache[2] = ($event: any) => (addFile($event))),
                    multiple: "",
                    uploadBtn: ""
                  }, null, 8, ["fileCount"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})